<template>
  <div class="class-manage">
    <div class="header">
      <el-input
        v-model="keyword"
        placeholder="搜索班级名称、学校或专业"
        style="width: 300px"
        @keyup.enter.native="search"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
      <el-button type="primary" @click="showAddDialog">新增班级</el-button>
    </div>

    <el-table :data="classList" style="width: 100%; margin-top: 20px">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="className" label="班级名称" />
      <el-table-column prop="collegeName" label="所属学校" />
      <el-table-column prop="majorName" label="所属专业" />
      <el-table-column prop="grade" label="年级" />
      <el-table-column prop="description" label="描述" />
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="small" @click="showEditDialog(scope.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :total="total"
      layout="total, prev, pager, next"
      @current-change="loadClassList"
      style="margin-top: 20px; text-align: center"
    />

    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="500px">
      <el-form :model="formData" label-width="100px">
        <el-form-item label="班级名称">
          <el-input v-model="formData.className" />
        </el-form-item>
        <el-form-item label="所属学校">
          <el-input v-model="formData.collegeName" placeholder="请输入学校名称" />
        </el-form-item>
        <el-form-item label="所属专业">
          <el-input v-model="formData.majorName" placeholder="请输入专业名称" />
        </el-form-item>
        <el-form-item label="年级">
          <el-input-number v-model="formData.grade" :min="2000" :max="2100" />
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="formData.description" type="textarea" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import classApi from '@/api/class'

export default {
  name: 'ClassManage',
  data() {
    return {
      keyword: '',
      classList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      formData: {
        id: null,
        className: '',
        collegeName: '',
        majorName: '',
        grade: new Date().getFullYear(),
        description: ''
      }
    }
  },
  mounted() {
    this.loadClassList()
  },
  methods: {
    async loadClassList() {
      try {
        const res = await classApi.getClassList(this.currentPage, this.pageSize, this.keyword)
        this.classList = res.data.data
        this.total = res.data.total
      } catch (error) {
        this.$message.error('加载班级列表失败')
      }
    },
    search() {
      this.currentPage = 1
      this.loadClassList()
    },
    showAddDialog() {
      this.dialogTitle = '新增班级'
      this.isEdit = false
      this.formData = {
        id: null,
        className: '',
        collegeName: '',
        majorName: '',
        grade: new Date().getFullYear(),
        description: ''
      }
      this.dialogVisible = true
    },
    async showEditDialog(row) {
      this.dialogTitle = '编辑班级'
      this.isEdit = true
      this.formData = { ...row }
      this.dialogVisible = true
    },
    async handleSubmit() {
      try {
        if (this.isEdit) {
          await classApi.updateClass(this.formData)
          this.$message.success('更新成功')
        } else {
          await classApi.addClass(this.formData)
          this.$message.success('添加成功')
        }
        this.dialogVisible = false
        this.loadClassList()
      } catch (error) {
        this.$message.error(this.isEdit ? '更新失败' : '添加失败')
      }
    },
    handleDelete(id) {
      this.$confirm('确定要删除这个班级吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await classApi.deleteClass(id)
          this.$message.success('删除成功')
          this.loadClassList()
        } catch (error) {
          this.$message.error('删除失败')
        }
      })
    }
  }
}
</script>

<style scoped>
.class-manage {
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
